import { Box, CircularProgress } from "@mui/joy";

export default function PlanningLoading() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
      <CircularProgress />
    </Box>
  );
}
